export default __webpack_public_path__ + "static/media/Finger-Rings.b620c7fc.jpg";